import { defineStore } from "pinia";

export const authModule = defineStore('auth',{
  state: () => ({
    user: null
  }),
  actions: {
    setUser(payload) {
      this.user = payload;
      localStorage.setItem('usr', JSON.stringify(payload));
    },
    async persistUser() {
      let usr = localStorage.getItem('usr');
      if (usr) {
        // Runs before mount, so a corrupt value would otherwise crash startup.
        try {
          this.setUser(JSON.parse(usr));
        } catch (e) {
          localStorage.removeItem('usr');
        }
      }
    },
    async fetchProfile() {
      try {
        let { data } = await this.$axios.get('/manager/profile')
        this.setUser(data);
      } catch (e) {
        console.log(e);
      }
    },
    logOut() {
      localStorage.removeItem("token");
      this.$router.push('/login')
      localStorage.removeItem("usr");
      localStorage.removeItem("pkg_search");
      localStorage.removeItem("clt_search");
      this.user = null;
    }
  },
  getters: {
    isLoggedIn(state)  {
      return !!state.user;
    },
    userObj: (state) => {
      return state.user;
    },
    /**
     * Whether the signed-in account may perform an action.
     *
     * Mirrors the API's auth.permit(): an `admin` - and a `hero` - passes every
     * check regardless of the permissions array, which is empty on those
     * accounts. Screens that tested the array alone therefore disabled every
     * button, and Settings showed "no permission to view any settings sections",
     * for the very accounts the API lets do anything.
     *
     * Not for the *_HIDDEN permissions: those hide a section from whoever holds
     * them, so an admin must not be treated as holding one.
     */
    can: (state) => (permission) => {
      if (!state.user) return false
      const type = String(state.user.account_type || '').trim().toLowerCase()
      if (type === 'admin' || type === 'hero') return true
      return (state.user.permissions || []).includes(permission)
    }
  }
})